export enum AssignableCompartment {
  Hubs = '/hubs',
  Compartments = '/compartments',
  Assignable = '/assignable',
}
